export default {
  id: 'locator.vehicleId',
  name: 'locator.vehicleId',
  displayName: 'Go To Vehicle',
  valueType: 'string',
  objectType: 'locator',
  get: obj => {
    return obj?.data?.vehicle?.id;
  }
};